<div class="backgroundDark">
    <h2 mat-dialog-title class="marginBottom0" fxFlex>Change Password</h2>
    <button mat-icon-button fxLayoutAlign="end center" (click)="close()">
        <mat-icon aria-label="Close" class="headerIconButton">close</mat-icon>
    </button>
</div>

<mat-dialog-content class="dialogContent">
    <mat-card class="profileCard">
        <form [formGroup]="changePasswordForm" (ngSubmit)="save(submitBtn)" novalidate autocomplete="off">
            <mat-card-content>
                <div>
                    <mat-form-field class="full-width" appearance="standard">
                        <mat-label>Current Password</mat-label>
                        <input matInput placeholder="Current Password" type="password" formControlName="password" required [type]="hide ? 'password' : 'text'">
                        <mat-icon matSuffix (click)="hide = !hide" class="showPasswordIcon">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        <mat-error *ngIf="changePasswordForm.controls.password.errors?.pattern">Should be at least 8 characters long and contain one number, one character and one special character</mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field class="full-width" appearance="standard">
                        <mat-label>New Password</mat-label>
                        <input matInput placeholder="New Password" type="password" formControlName="newPassword" required [type]="newHide ? 'password' : 'text'">
                        <mat-icon matSuffix (click)="newHide = !newHide" class="showPasswordIcon">{{newHide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        <mat-error *ngIf="changePasswordForm.controls.newPassword.errors?.pattern">Should be at least 8 characters long and contain one number, one character and one special character</mat-error>
                        <mat-error *ngIf="changePasswordForm.controls.newPassword.errors?.match">New Password must be different from current one</mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field class="full-width" appearance="standard">
                        <mat-label>Confirm Password</mat-label>
                        <input matInput placeholder="Password" type="password" formControlName="confirmPassword" required [type]="hideConfirm ? 'password' : 'text'">
                        <mat-icon matSuffix (click)="hideConfirm = !hideConfirm" class="showPasswordIcon">{{hideConfirm ? 'visibility_off' : 'visibility'}}</mat-icon>
                        <mat-error *ngIf="changePasswordForm.controls.confirmPassword.errors?.match">New Passwords must match</mat-error>
                    </mat-form-field>
                </div>
            </mat-card-content>
        </form>
    </mat-card>
</mat-dialog-content>

<mat-dialog-actions fxLayoutAlign="end center">
    <button class="mat-raised-button dialogActionButton" (click)="close()" mat-button type="button">Cancel</button>
    <button class="mat-raised-button mat-primary dialogActionButton" [disabled]="changePasswordForm.invalid || !changePasswordForm.dirty" type="submit" mat-button #submitBtn>Save</button>
</mat-dialog-actions>
